import MultiplePlaylistsEmpty from './MultiplePlaylistsEmpty'

export default MultiplePlaylistsEmpty
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsEmpty'
